export const TRADE_IN_ACTIONS = {
  FETCH_TRADE_IN: 'EULA:FETCH_TRADE_IN',
  FETCH_TRADE_IN_SUCCESS: 'EULA:FETCH_TRADE_IN_SUCCESS',
  FETCH_TRADE_IN_ERROR: 'EULA:FETCH_TRADE_IN_ERROR',
};
